import { Component, OnInit, Input, ChangeDetectionStrategy } from '@angular/core';
import { PopoverController, AlertController } from '@ionic/angular/lazy';
import { PermissionService } from 'src/app/services/permission.service';

@Component({
    selector: "app-organisation-shipping-address-options",
    templateUrl: "./organisation-shipping-address-options.component.html",
    styleUrls: ["./organisation-shipping-address-options.component.scss"],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})

export class OrganisationShippingAddressOptionsComponent implements OnInit {

    @Input() shipping_address_page = null;

    constructor(
        private popoverCtrl: PopoverController,
        public alertController: AlertController,
        public permissionService: PermissionService
    ) { }

    ngOnInit() {
    }

    edit() {
        this.shipping_address_page.presentEditShippingAddressModal();
        this.dismiss();
    }

    async presentDeleteAlert() {
        const alert = await this.alertController.create({
            header: "Are you sure?",
            message: "Deleting a shipping address is permanent and it can't be restored.",
            cssClass:"alert",
            buttons: [
                {
                    text: 'Cancel',
                    role: 'cancel'
                },
                {
                    text: 'OK',
                    handler: () => {
                        this.shipping_address_page.deleteOrganisationShippingAddress();
                        this.dismiss();
                    }
                }
            ],
        });
        await alert.present();
    }

    async dismiss() {
        try {
            await this.popoverCtrl.dismiss();
        } catch (e) {
            // click more than one time popover throws error, so ignore...
        }
    }



}
